import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class PersonService {
  private currentUser: any;

  constructor(private http: HttpService) {}

  getCurrentUser() {
    if (this.currentUser) {
      return Promise.resolve(this.currentUser);
    }

    return this.fetchCurrentUser();
  }

  private fetchCurrentUser() {
    return this.http.get(`${environment.SERVER_URL}/person/currentUser`);
  }

  getUserDetails(userId) {
    return this.http.get(`${environment.SERVER_URL}/person/detail/${userId}`);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/service/person.service.ts